<template>
    <div class="confirmationlayout">
        <span class="logintext">{{$t('Login.SignUp.CHECKING_YOUR_EMAIL_DESC')}}</span>
        <br/>
         <v-progress-linear v-if="loading"
            color="primary"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
    </div>
</template>
<script>
import accountApi from '@/services/AccountApi'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      loading: true,
      snackbarFailed: {
        show: true,
        color: 'error',
        text: this.$t('Login.SignUp.ACTIVATE_ACCOUNT_ERROR'),
        timeout: 6000
      },
      snackbarSuccess: {
        show: true,
        color: 'success',
        text: this.$t('Login.SignUp.YOUR_ACCOUNT_HAS_BEEN_ACTIVATED_DESC'),
        timeout: 6000
      }
    }
  },
  methods: {
    async verfiyUserMail () {
      let token = this.$route.query.token
      let success = false
      if (token) {
        success = await accountApi.validateUserEmail(token)
      }
      setTimeout(() => this.showResult(success), 2000)
    },
    showResult (success) {
      this.loading = false
      if (success) {
        this.$store.dispatch('global/setSnackbar', this.snackbarSuccess)
        this.$router.push({ path: '/login' })
      } else {
        this.$store.dispatch('global/setSnackbar', this.snackbarFailed)
      }
    }
  },
  computed: {
    ...mapState('countries', ['countriesWithFlag'])
  },
  async mounted () {
    await this.verfiyUserMail()
  }
}
</script>
